import { Button, Checkbox, Modal, Spin } from "antd";
import { showError } from "common/ToastNotifications";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import FormFieldReadOnly from "components/atoms/FormFieldReadOnly";
import { Component } from "react";
import { connect } from "react-redux";
import actions from "store/actions";

class NominatedValueSelectionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: true,
            selectedValue: this.props.selectedValue,
        };
    }

    componentWillMount() {
        this.props.getNominatedValueDataObjects(
            this.props.fieldName,
            this.props.dataObjectGroup.map((item) => ({
                businessAreaId: item._businessAreaId,
                schemaId: item._schemaId,
                dataSetId: item._dataSetId,
                dataObjectId: item._dataObjectId,
            })),
        );
    }

    componentDidMount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetNominatedValueDataObjectsRequestResultChanged(prevProps);
    }

    onGetNominatedValueDataObjectsRequestResultChanged = (prevProps) => {
        if (this.props.getNominatedValueDataObjectsRequestResult && this.props.getNominatedValueDataObjectsRequestResult !== prevProps.getNominatedValueDataObjectsRequestResult) {
            if (!this.props.getNominatedValueDataObjectsRequestResult.success) {
                showError("Unable to get records at this moment");
            }
        }
    };

    onOkClicK = () => {
        this.setState({
            showModal: false,
        });
        this.props.onOkClick(this.state.selectedValue);
    };

    onCancelClick = () => {
        this.setState({
            showModal: false,
        });
        this.props.onCancelClick();
    };

    onValueSelectionChanged = (dataObjectId, fieldId) => {
        this.setState({
            selectedValue: {
                dataObjectId,
                fieldId,
            },
        });
    };

    render() {
        return (
            <Modal
                destroyOnHidden={true}
                closable={false}
                maskClosable={false}
                keyboard={false}
                title="Select Value"
                style={{ top: 20 }}
                open={this.state.showModal}
                onOk={this.onOkClicK}
                onCancel={this.onCancelClick}
                styles={{
                    body: { height: "80vh", minHeight: "50vh", paddingTop: "0px" },
                }}
                width="80%"
                footer={null}
            >
                <FlexContainerLayout
                    showHeader={this.props.getNominatedValueDataObjectsRequestResult.inProgress}
                    header={<Spin className="inline-spin-text" tip="Getting records..." size="small"></Spin>}
                    headerStyle={{ paddingTop: "1rem", paddingBottom: "1rem" }}
                    showFooter={true}
                    footerClassName="justify-end gap-2"
                    footer={
                        <>
                            <Button onClick={this.onCancelClick}>Cancel</Button>
                            <Button type="primary" onClick={this.onOkClicK}>
                                Save
                            </Button>
                        </>
                    }
                >
                    {this.props.nominatedValueDataObjects.Items.map((item) => {
                        return item.schemaModel && item.dataObject ? (
                            <div className="flex gap-2" key={`nominated-${item.dataObject.dataObjectId}`}>
                                <Checkbox
                                    checked={this.state.selectedValue && this.state.selectedValue.dataObjectId === item.dataObject.dataObjectId}
                                    onChange={() => this.onValueSelectionChanged(item.dataObject.dataObjectId, item.schemaModel.fields[0].fieldId)}
                                ></Checkbox>
                                <div className="flex flex-1">
                                    <FormFieldReadOnly
                                        name={item.schemaModel.fields[0].name}
                                        description={item.schemaModel.fields[0].description}
                                        label={
                                            <div className="flex gap-1 rounded-sm bg-slate-100 px-2 py-1 text-xs">
                                                <b>Schema:</b>
                                                {item.schemaModel.name}
                                            </div>
                                        }
                                    >
                                        {item.dataObject[item.schemaModel.fields[0].fieldId] ?? ""}
                                    </FormFieldReadOnly>
                                </div>
                            </div>
                        ) : (
                            <></>
                        );
                    })}
                </FlexContainerLayout>
            </Modal>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getNominatedValueDataObjectsRequestResult: state.nominatedValueSelectionList.getNominatedValueDataObjectsRequestResult,
        nominatedValueDataObjects: state.nominatedValueSelectionList.nominatedValueDataObjects,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getNominatedValueDataObjects: (nominatedRecordFieldName, dataObjectRequests) =>
            dispatch(actions.getNominatedValueDataObjectsRequest(nominatedRecordFieldName, dataObjectRequests)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NominatedValueSelectionList);
